<template>
  <el-dialog :visible.sync="dialogVisible" style="z-index:1501" width="30%" :close-on-click-modal="false" :modal="false">
    <template v-if="dialogType==='部2部'">
      <!-- 部门拖拽到部门上，弹出设置选项 -->
      <span>操作：</span>
      <el-radio-group v-model="dialogResult" size="small">
        <el-radio :label="'平级'" class="mbl10" border>变为平级部门</el-radio>
        <el-radio :label="'下级'" class="mb10" border>变为下级部门</el-radio>
        <el-radio :label="mergeDepartmentOne._id" class="mb10" border>合并部门（{{ mergeDepartmentOne.名称 }}为主）</el-radio>
        <el-radio :label="mergeDepartmentTwo._id" class="mb10" border>合并部门（{{ mergeDepartmentTwo.名称 }}为主）</el-radio>
      </el-radio-group>
    </template>
    <template v-else-if="dialogType==='移动高管'">
      <!-- 部门拖拽到部门上，弹出设置选项 -->
      <span>操作：</span>
      <el-radio-group v-model="dialogResult" size="small">
        <el-radio :label="'平级'" class="mbl10" border>变为平级部门</el-radio>
        <el-radio :label="'下级'" class="mb10" border>变为下级部门</el-radio>
      </el-radio-group>
    </template>


    <template v-else-if="dialogType==='高管'">
      <!-- 部门拖拽到部门上，弹出设置选项 -->
      <span>操作：</span>
      <el-radio-group v-model="dialogResult" size="small">
        <el-radio :label="'平级'" class="mbl10" border>变为平级部门</el-radio>
        <el-radio :label="'下级'" class="mb10" border>变为下级部门</el-radio>
      </el-radio-group>
    </template>
    <template v-else-if="dialogType==='人2人'">
      <!-- 人选拖拽到人选上，弹出设置选项 -->
      <span>新建组别，请选择组别名称：</span>
      <el-radio-group v-model="dialogResult" size="small">
        <el-radio :label="dragRadishOne._id" class="mbl10" border>{{ dragRadishOne.姓名 }}组</el-radio>
        <el-radio :label="dragRadishTwo._id" class="mb10" border>{{ dragRadishTwo.姓名 }}组</el-radio>
      </el-radio-group>
    </template>
    <template v-else-if="dialogType==='人2部'">
      <!-- 人选拖到部门上，弹出选项 -->
      <el-radio-group v-model="dialogResult">
        <el-radio label="A角">A角</el-radio>
        <el-radio label="B角">B角</el-radio>
        <el-radio label="团队长">团队长</el-radio>
        <el-radio label="无">无</el-radio>
        <!-- <el-radio label="高管">分管领导</el-radio> -->
      </el-radio-group>
    </template>
    <template v-else-if="dialogType==='改名'">
      <!-- 修改部门名称 -->
      <span>请输入修改后的{{btnText}}名称：</span>
      <div><el-input v-model="dialogResult" placeholder="请输入内容"></el-input></div>
    </template>
    <!-- <template v-else-if="dialogType==='高管'">
      设置高管
      <el-alert title="建议以人选的管理职级命名" type="warning"></el-alert>
      <span>部门名：</span>
      <div><el-input v-model="dialogResult" placeholder="请输入内容"></el-input></div>
    </template> -->
    <template v-else-if="dialogType==='合并部门'">
      <!-- 合并部门 -->
      <el-alert title="选择被合并的组别,选完之后可以查看详情" type="warning"></el-alert>
      <span>部门名：</span>
      <div>
        <el-select v-model="dialogResult" size="mini" filterable placeholder="请选择">
          <el-option
            v-for="item in departmentOption"
            :key="item._id"
            :label="item.部门"
            :value="item.部门">
          </el-option>
        </el-select>
        <el-button size="mini" type="primary" plain @click.stop="showDepartmentMember">查看此部门人员</el-button>
      </div>
    </template>
    <template v-else>
      <!-- 添加部门 -->
      <el-input v-model="dialogResult" placeholder="请输入部门名称" class="input-with-select">
        <!-- TODO:增加新增上级部门的功能 -->
        <!-- <el-select
          v-model="departmentPosition"
          slot="prepend"
          style="width:95px"
          placeholder="请选择"
        >
          <el-option label="上级部门" value="上级部门"></el-option>
          <el-option label="下级部门" value="下级部门"></el-option>
        </el-select> -->
      </el-input>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    btnText: { type: String, default: '部门' },
  },
  data() {
    return {
      dialogVisible: false,
      dialogType: '',
      dialogResult: '',
      mergeDepartmentOne: '',
      mergeDepartmentTwo: '',
      dragRadishOne: '',
      dragRadishTwo: '',
      departmentPosition: '下级部门',
      departmentOption: [],
      mergeMainDepartmentId: null,
    }
  },
  methods: {
    open(type, params) {
      this.dialogVisible = true
      this.dialogType = type
      this.dialogResult = ''
      this.departmentPosition = '下级部门'
      this.mergeMainDepartmentId = null
      if (type === '部2部') {
        this.mergeDepartmentOne = params[0]
        this.mergeDepartmentTwo = params[1]
      } else if (type === '人2人') {
        this.dragRadishOne = params[0]
        this.dragRadishTwo = params[1]
      } else if (type === '高管') {
        this.dialogResult = params
      } else if (type === '合并部门') {
        this.setDepartmentOption(params)
        this.mergeMainDepartmentId = params._id
      }
    },
    async setDepartmentOption(department) {
      const res = await app.service('company').getCompanyOchart({ 公司: department.公司 })
      if (res.status == 'success') {
        this.departmentOption = res.data.filter(v=>v.人数&&v.人数!==0)
      }
    },
    showDepartmentMember() {
      if (!this.dialogResult) return this.$message('请选择部门')
      const val = this.departmentOption.find(v => v.部门 === this.dialogResult)
      const option = { company: val.公司, department: val.部门 }
      app.root.$refs.companyTwoThird.open(option)
    },
    cancel() {
      this.dialogVisible = false
      this.$emit('cancel', this.dialogType)
    },
    confirm() {
      if (!this.dialogResult && this.dialogType !== '人2部') this.cancel()
      else if (this.dialogType === '合并部门') {
          const val = this.departmentOption.find(v => v.部门 === this.dialogResult)
          if (this.mergeMainDepartmentId === val) return this.$message.error('所选部门未同一部门，请重新选择')

          this.$emit('confirm', {
            result: val,
            dialogType: this.dialogType,
            departmentPosition: this.departmentPosition,
          })
        } else {
          this.$emit('confirm', {
            result: this.dialogResult,
            dialogType: this.dialogType,
            departmentPosition: this.departmentPosition,
          })
        }
      this.dialogVisible = false
    },
  },
}
</script>
<style scpoed>
.mb10 {
  margin-bottom: 10px;
}
.mbl10 {
  margin: 0 0 10px 10px;
}
</style>
